import { render, staticRenderFns } from "./EditCampaign.smartlinks.vue?vue&type=template&id=b4852520&scoped=true&lang=html&"
import script from "./EditCampaign.smartlinks.vue?vue&type=script&lang=js&"
export * from "./EditCampaign.smartlinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4852520",
  null
  
)

export default component.exports